import { EmployeeProductivityList } from 'components/hr-metrics/employee-productivity/EmployeeProductivityList';
import { ACTION_TYPE } from 'constants/constant';
import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { INITIAL_DATA_QUERY } from "../../../configs/hr-metrics/configTableEmployeeProductivityList";
import { API_EMPLOYEE_PRODUCTIVITY } from "../../../services/apiEmployeeProductivity";
import { useFetch } from "../../../services/useFetch";
import {
    downloadFile,
    getAllQueryParams,
    setQueryParams
} from "../../../utils/utils";

const FILTER_PARAMS = ['departments', 'divisions']

const EmployeeProductivityListContainer = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const [queryFilter, setQueryFilter] = useState()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_QUERY
    const [isShowToast, setIsShowToast] = useState(false)
    const [toastMessage, setToastMessage] = useState('')
    const [selectedIds, setSelectedIds] = useState([])
    const [selectedDeleteId, setSelectedDeleteId] = useState(null)
    const [modal, setModal] = useState({
        export: false,
        limit: false,
    })
    const {data: periodProductivity, fetching: getPeriodProductivity, isLoading} = useFetch(API_EMPLOYEE_PRODUCTIVITY.LIST_PERIOD)
    const {fetching: exportPeriodProductivity} = useFetch(API_EMPLOYEE_PRODUCTIVITY.EXPORT_PERIOD)
    const {fetching: deletePeriodProductivity, isLoading: isDeleting} = useFetch(API_EMPLOYEE_PRODUCTIVITY.DELETE_PERIOD)

    useEffect(() => {
        getPeriodList()
    }, [location?.search])

    const getPeriodList = async () => {
        const newQuery = {...query}
        const newQueryFilter = {}
        Object.entries(newQuery).forEach(([key, item]) => {
            if (FILTER_PARAMS.includes(key)) {
                const valueOfQuery = FILTER_PARAMS.includes(key) ? item.split(',') : item
                newQuery[key] = valueOfQuery
                newQueryFilter[key] = valueOfQuery
            }
        })
        setQueryFilter(newQueryFilter)
        getPeriodProductivity(newQuery)
    }

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({...query, ...queryParams})
        setSearchParams(params, {replace: true})
    }

    const clearToast = () => {
        setIsShowToast(false)
        setToastMessage('')
    }

    const showToast = (message) => {
        setIsShowToast(true)
        setToastMessage(message)
    }

    const setShowModal = (value) => {
        setModal({...modal, ...value})
    }

    const onClickItemHandler = ({item, actionType}) => {
        switch (actionType) {
            case ACTION_TYPE.DETAIL:
                if (item.status === 'submitted') {
                    navigate(`/human-resource-metrics/employee-productivity/detail-employee-productivity?periodId=${item?.id}`)
                } else {
                    navigate(`/human-resource-metrics/create-employee-productivity/import-data?periodId=${item?.id}`)
                }
                break
            case ACTION_TYPE.DELETE:
                setSelectedDeleteId(item?.id)
                setShowModal({delete: true})
                break
            default:
                break
        }
    }

    const onExportHandler = () => {
        const { page, limit, ...payload } = query
        const body = {
            ...payload, 
            departments: queryFilter?.departments || [],
            divisions: queryFilter?.divisions || [],
            period_ids: selectedIds.map(item => item.id ),
        }

        exportPeriodProductivity(body, '', {}, 'blob')
            .then(res => {
                downloadFile(null, res, `Period-Productivity-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
                setShowModal({export: false})
                showToast('Export Data Berhasil !!')
            })
    }

    const onDelete = () => {
        deletePeriodProductivity(null, selectedDeleteId)
            .then(() => {
                setModal({...modal, delete: false})
                showToast('Period Productivity Deleted !!')
                getPeriodList()
            })
    }

    const props = {
        dataList: periodProductivity?.data,
        isLoading,
        isDeleting,
        query,
        queryFilter,
        navigate,
        toast: {
            isShowToast,
            message: toastMessage
        },
        modal,
        selectedIds,
        setShowModal,
        setSelectedIds,
        clearToast,
        onChangeQuery,
        onClickItemHandler,
        onExportHandler,
        onDelete,
    }

    return <EmployeeProductivityList {...props} />
}

export default EmployeeProductivityListContainer
